
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row, Button, Form, Input, Label, FormFeedback, Spinner } from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { toast } from 'react-toastify';
import { sendUserAttributeVerificationCode, confirmUserAttribute } from 'aws-amplify/auth';
import logo from "../../assets/images/White Logo-1 1.png";
import { useNavigate } from 'react-router-dom';

const EmailVerify = (props) => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState(["", "", "", "", "", ""]); // State to store OTP digits
    const [loading, setLoading] = useState(false);
    const moveToNext = (index) => {
        if (document.getElementById(`digit${index}-input`).value.length === 1) {
            if (index !== 6) {
                document.getElementById(`digit${index + 1}-input`).focus();
            } else {
                document.getElementById(`digit${index}-input`).blur();
            }
        }
    };

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
    };
    const validation = useFormik({
        initialValues: {
            email: sessionStorage.getItem("Email") || "",
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Invalid email").required("Email is required"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                // Verify OTP
                const otpCode = otp.join("");
                await confirmUserAttribute({ userAttributeKey: 'email', confirmationCode:otpCode });
                toast.success("Email verified successfully!");
                navigate("/dashboard");
            } catch (error) {
                toast.error(error.message || "Error verifying email");
            }
            setLoading(false);
        }
    });

    const mail = validation.values.email

    const handleGetCode = async () => {
        setLoading(true);
        try {
            console.log(validation.values.email);
            const res = await sendUserAttributeVerificationCode({ userAttributeKey: "email" });
            console.log(res);
            
            toast.info("Verification code sent to your email!");
        } catch (error) {
            toast.error(error.message || "Error sending verification code");
            console.log("message", error.message);
        }
        setLoading(false);
    };

    document.title = "Offiso Admin Platform | Email Verify";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container>
                <BreadCrumb title="Verify Email" pageTitle="" />
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-2">
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Verify Your Email!</h5>
                                        <p className="text-muted">Enter the code sent to your email to verify.</p>
                                    </div>
                                    <div className="p-2 mt-4">
                                        <Form onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}>
                                            <div className="mb-3">
                                                <Label htmlFor="email" className="form-label">Email</Label>
                                                <Input
                                                    disabled
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter email"
                                                    type="email"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email || ""}
                                                    invalid={validation.touched.email && validation.errors.email ? true : false}
                                                    readOnly
                                                />
                                                {validation.touched.email && validation.errors.email && (
                                                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                )}
                                            </div>

                                            <div className="text-center mt-3 mb-3">
                                                <Link to="#" onClick={handleGetCode}>
                                                    {loading ? <Spinner size="sm" /> : "Get Verification Code"}
                                                </Link>
                                            </div>

                                            <div className="mb-3">
                                                <Label className="form-label">Enter Received Code</Label>
                                                <Row>
                                                    {[1, 2, 3, 4, 5, 6].map((index) => (
                                                        <Col className="col-2" key={index}>
                                                            <div className="mb-3 mt-3">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control form-control-lg bg-light border-light text-center p-2"
                                                                    maxLength="1"
                                                                    id={`digit${index}-input`}
                                                                    onKeyUp={() => moveToNext(index)}
                                                                    onChange={(e) => handleOtpChange(index - 1, e.target.value)} // Store OTP digits
                                                                />
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>

                                            <div className="mt-4">
                                                <Button color="success" disabled={loading} className="btn btn-success w-100" type="submit">
                                                    {loading ? <Spinner size="sm" className='me-2' /> : "Verify"}
                                                </Button>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default EmailVerify;

